module.exports = __webpack_public_path__ + "img/icon15.adc812d0.svg";